import { forwardRef, LabelHTMLAttributes } from "react";

export interface LabelProps
  extends Omit<LabelHTMLAttributes<HTMLLabelElement>, "children"> {
  text: string | React.ReactNode;
  subtext?: string;
}

export const Label = forwardRef<HTMLLabelElement, LabelProps>(
  ({ subtext, text, ...props }, ref) => (
    <label {...props} ref={ref}>
      <div className="body-2 text-2xl text-brand">{text}</div>
      {subtext != null ? (
        <div className="body-2 mt-3 font-light">{subtext}</div>
      ) : null}
    </label>
  ),
);

Label.displayName = "Label";
